<template>
  <yh-menu :menu-data="menuData" />
</template>

<script>
import YhMenu from './yh-menu.vue';

export default {
  name: 'HorizontalNav',
  components: {
    YhMenu,
  },
  data() {
    return {
      menuData: [],
    };
  },
  mounted() {
    this.listMenus();
  },
  methods: {
    // 获取菜单数据
    listMenus() {
      this.menuData = this.$store.getters.menuList.filter(item => item.menuName !== '主页');
    },
  },
};
</script>
